'use strict';

import {DebuggableObject} from './DebuggableObject.js';
import * as Colors from './Colors.js';
import {i18n} from './../AppInterface/lib/i18n.js';
import $ from 'jquery';

export class Glossar extends DebuggableObject {
    constructor(texts) {
        super('Glossar', Colors.purple);
        this.texts = texts || {};
    }

    getText(key) {
        const lang = i18n.language;

        if (this.texts[key] && this.texts[key][lang]) {
            return this.texts[key][lang];
        } else {
            if (!this.texts[key]) {
                this.log(Colors.orange, 'no glossar entry for ' + key + '[' + lang + ']', JSON.parse(JSON.stringify(this.texts)));
            } else {
                this.log(Colors.orange, 'no language ' + lang + ' entry for key ' + key + ']', JSON.parse(JSON.stringify(this.texts)));
            }
            return key;
        }
    }

    add(texts) {
        this.texts = $.extend(this.texts, texts);
    }
}

export const glossar = new Glossar();